// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"2ca761f5","264":"806d8631","480":"6b886a12","638":"a1afb06c","738":"5b53bef2"}[chunkId] + ".chunk.js";
};